import React, { useState, Fragment, useRef, useEffect } from 'react';

import { Row, Col, Button, Tab, Nav, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useValidation } from '../../../hooks/validationHooks/useValiation';
import { appointmentSchema } from '../../../validationSchemas/appointment.validation';
import LoadingButton from '../../../components/forms/LoadingButton';
import { toast } from 'react-toastify';
import { useClickAway } from 'react-use';
import {
  separateDateTime,
  agePrint,
  capitalizeFirstLetter,
} from '../../../utils/helpers';

import avatarMale from '../../../assets/images/avatar_male.jpeg';
import avatarFemale from '../../../assets/images/avatar_female.jpeg';
import BasicPatientForAppointment from '../../../components/doctors/partials/basicPatientForAppointment';
import OthersPatientInfo from '../../../components/doctors/partials/othersPatientInfo';
import WebcamCapture from '../../../components/doctors/modals/WebcamCapture';
import { deleteRequest } from '../../../utils/axiosRequests';
import MedicalPatientForAppointment from '../../../components/doctors/partials/medicalPatientForAppointment';
import { useGetRequest } from '../../../hooks/useGetRequest';

function AddPatientInfo({
  patientPicture,
  patientInfo,
  setPatientInfo,
  infoModal,
  setInfoModal,
  selectedOnExamination,
  setSelectedOnExamination,
  appointmentInfo,
  setAppointmentInfo,
  fromPage = '',
  handleSubmit = '',
}) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [patientId, setPatientId] = useState('');
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [errors, setErrors] = useState({});
  const [appointmentDateTime, setAppointmentDateTime] = useState('');
  const [visitType, setVisitType] = useState('new');
  const [visitationFee, setVisitationFee] = useState('');
  const [patientType, setPatientType] = useState('new');
  const [doctorPatientId, setDoctorPatientId] = useState([]);

  const userInfo = useSelector((state) => state.authReducer.data);
  const validation = useValidation;

  const ref = useRef(null);
  useClickAway(ref, () => {
    setInfoModal(false);
  });

  const patientSettings = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.patientSettings,
  );
  const ageProperties = patientSettings?.items?.find(
    (item) => item.name === 'age',
  );
  let { unitProperties } = ageProperties || {};
  let navigate = useNavigate();

  const deletePatientImage = () => {
    if (patientPicture) {
      const confirmDelete = window.confirm(
        'Are you sure you want to delete this image?',
      );
      // Proceed with deletion if confirmed
      if (confirmDelete) {
        deleteRequest(`auth/patient-img-delete/${patientInfo.id}`)
          .then((res) => {
            console.log(res, 'deletePatientImage');
          })
          .catch((error) => {});
      }
    } else {
      setImageSrc(null);
    }
  };

  const selectSearchResult = (selectedUser) => {
    const patient = selectedUser[0];
    setPatientInfo({ ...patient, gender: patient?.gender?.toLowerCase() || 'male' });
    setPatientId(patient?.id);
  };

  const getPatientIdForDoctor = (idList) => {
    let patientId = '';
    idList?.forEach((item) => {
      if (item.doctorId === userInfo.id) {
        patientId = item.patientId;
      }
    });
    return patientId;
  };

  useEffect(() => {
    const doctorPatientId = getPatientIdForDoctor(
      patientInfo?.patientIdForDoctor,
      userInfo,
    );
    console.log('working for patient Id : test patientId', patientInfo);
    setDoctorPatientId(doctorPatientId);
  }, [patientInfo]);

  const getAvatarImage = () => {
    if (imageSrc) return imageSrc;
    else if (patientPicture) return patientPicture;
    else if (patientInfo?.gender === 'female') return avatarFemale;
    else return avatarMale;
  };

  return (
    <Modal show={infoModal} dialogClassName="custom-modal-width">
      <Modal.Header className="common-modal-header">
        <Col lg={10} md={10} sm={10} xs={10}>
          <Modal.Title>Patient Details</Modal.Title>
        </Col>
        <Col lg={1} md={1} sm={1} xs={1} style={{ textAlign: 'end' }}>
          <i
            onClick={() => {
              setInfoModal(false);
            }}
            className="far fa-times-circle cursor-pointer"
            aria-hidden="true"
          ></i>
        </Col>
      </Modal.Header>
      <Modal.Body ref={ref}>
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="patient-history patient-info">
                <Row>
                  <Col
                    md={3}
                    className="patient-details my-2"
                    style={{ fontSize: '15px' }}
                  >
                    <div className="card shadow py-3 px-1">
                      <div className="icon-list">
                        {/* <i
                          className="fa fa-plus-circle"
                          onClick={() => setIsOpenCamera(true)}
                        ></i>
                        <i
                          className="fa fa-edit"
                          onClick={() => setIsOpenCamera(true)}
                        ></i> */}
                        {(patientPicture || imageSrc) && (
                          <i
                            className="far fa-times-circle cursor-pointer"
                            onClick={() => deletePatientImage()}
                          ></i>
                        )}
                      </div>
                      <div className="patient-img-info">
                        {!isOpenCamera ? (
                          <img
                            className="profile-img"
                            alt="Avatar"
                            src={
                              patientInfo?.gender === 'female'
                                ? getAvatarImage()
                                : getAvatarImage()
                            }
                          />
                        ) : (
                          <>
                            <WebcamCapture
                              imageSrc={imageSrc}
                              setImageSrc={setImageSrc}
                              isOpenCamera={isOpenCamera}
                              patientInfo={patientInfo}
                              setPatientInfo={setPatientInfo}
                              setIsOpenCamera={setIsOpenCamera}
                            />
                          </>
                        )}
                        <div className="patient-name">{patientInfo?.name}</div>
                        <div className="patient-pid mt-2">
                          <span>Patient ID:</span>
                          {doctorPatientId}
                        </div>
                        <div className="patient-age">
                          <span>Age:</span>
                          {agePrint(
                            separateDateTime(patientInfo?.dob),
                            unitProperties,
                          )}
                        </div>
                        <div className="center">
                          <button
                            className="small-btn mt-2 mb-3"
                            onClick={(e) => {
                              setIsOpenCamera(true);
                              e.preventDefault();
                            }}
                          >
                            Edit Picture
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* <hr /> */}
                    <div className="card shadow py-3 my-3 black">
                      <h5 className="center">Information</h5>
                      <div>
                        <span className="information_span pr-2">Gender:</span>
                        {capitalizeFirstLetter(patientInfo?.gender)}
                      </div>
                      <div>
                        <span className="information_span pr-2">Height:</span>
                        {selectedOnExamination?.generalExaminations?.heightInfo
                          ?.feet || 'n/a'}{' '}
                        {selectedOnExamination?.generalExaminations?.heightInfo
                          ?.feet
                          ? 'Ft '
                          : ''}{' '}
                        {selectedOnExamination?.generalExaminations?.heightInfo
                          ?.inch || ''}{' '}
                        {selectedOnExamination.generalExaminations?.heightInfo
                          ?.inch
                          ? ' inch'
                          : ''}
                      </div>
                      <div>
                        <span className="information_span pr-2">Weight:</span>
                        {selectedOnExamination?.generalExaminations?.weightInfo
                          ?.weight
                          ? selectedOnExamination.generalExaminations
                              ?.weightInfo?.weight +
                            ' ' +
                            selectedOnExamination.generalExaminations
                              ?.weightInfo?.weightUnit
                          : 'n/a'}
                      </div>
                      <div>
                        <span className="information_span pr-2">Phone No:</span>
                        {patientInfo?.phoneNumber
                          ? patientInfo?.phoneNumber
                          : 'n/a'}
                      </div>
                      <div>
                        <span className="information_span pr-2">
                          Blood Group:{' '}
                        </span>
                        {selectedOnExamination?.generalExaminations
                          ?.bloodGroup || 'n/a'}
                      </div>
                    </div>
                    {/* <Row className="text-center">
                      <Col>
                        <Row>
                          <Col>
                            <div className="label-bold">Gender</div>
                            <div className="mt-2 greyColor">
                              {capitalizeFirstLetter(patientInfo?.gender)}
                            </div>
                            <hr />
                          </Col>
                          <Col>
                            <div className="label-bold">Age</div>
                            <div className="mt-2 greyColor">
                              {agePrint(
                                separateDateTime(patientInfo?.dob),
                                unitProperties,
                              )}
                            </div>
                            <hr />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="label-bold">Height</div>
                            <div className="mt-2 greyColor">
                              {
                                selectedOnExamination?.generalExaminations
                                  ?.heightInfo?.feet
                              }
                              {selectedOnExamination?.generalExaminations
                                ?.heightInfo?.inch
                                ? '.' +
                                  selectedOnExamination.generalExaminations
                                    ?.heightInfo?.inch
                                : ''}
                              {selectedOnExamination?.generalExaminations
                                ?.heightInfo?.feet ||
                              selectedOnExamination.generalExaminations
                                ?.heightInfo?.inch
                                ? ' ' +
                                  selectedOnExamination.generalExaminations
                                    ?.heightInfo?.heightUnit
                                : ''}
                            </div>
                            <hr />
                          </Col>
                          <Col>
                            <div className="label-bold">Weight</div>
                            <div className="mt-2 greyColor">
                              {selectedOnExamination?.generalExaminations
                                ?.weightInfo?.weight
                                ? selectedOnExamination.generalExaminations
                                    ?.weightInfo?.weight +
                                  ' ' +
                                  selectedOnExamination.generalExaminations
                                    ?.weightInfo?.weightUnit
                                : ''}
                            </div>
                            <hr />
                          </Col>
                        </Row>
                      </Col>
                    </Row> */}
                  </Col>
                  <Col md={9} className="pl-4">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="basic"
                    >
                      <Nav
                        variant="pills"
                        className="d-flex custom-tab"
                        style={{
                          alignItems: 'center',
                          textAlign: 'center',
                        }}
                      >
                        <Nav.Item className="flex-fill">
                          <Nav.Link eventKey="basic">
                            Patient Information
                          </Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item className="flex-fill">
                          <Nav.Link eventKey="medical">
                            Medical Information
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="flex-fill">
                          <Nav.Link eventKey="others">Others</Nav.Link>
                        </Nav.Item> */}
                      </Nav>
                      <Tab.Content>
                        <Tab.Pane
                          eventKey="basic"
                          className="card shadow"
                          style={{
                            height: '452px',
                            overflowY: 'auto',
                          }}
                        >
                          <BasicPatientForAppointment
                            patientInfo={patientInfo}
                            setPatientInfo={setPatientInfo}
                            selectSearchResult={selectSearchResult}
                            setPhoneNumber={setPhoneNumber}
                            phoneNumber={phoneNumber}
                            appointmentInfo={appointmentInfo}
                            patientType={patientType}
                            setPatientType={setPatientType}
                            errors={errors}
                            setAppointmentDateTime={setAppointmentDateTime}
                            visitType={visitType}
                            setVisitType={setVisitType}
                            setVisitationFee={setVisitationFee}
                            isEdit={false}
                          />
                          <MedicalPatientForAppointment
                            patientInfo={patientInfo}
                            setPatientInfo={setPatientInfo}
                            selectedOnExamination={selectedOnExamination}
                            appointmentInfo={appointmentInfo}
                            setAppointmentDateTime={setAppointmentDateTime}
                            setSelectedOnExamination={setSelectedOnExamination}
                          />
                          <OthersPatientInfo
                            patientInfo={patientInfo}
                            setPatientInfo={setPatientInfo}
                            appointmentInfo={appointmentInfo}
                            setAppointmentInfo={setAppointmentInfo}
                          />
                        </Tab.Pane>
                        {/* <Tab.Pane eventKey="medical">

                        </Tab.Pane>
                        <Tab.Pane eventKey="others">

                        </Tab.Pane> */}
                        {fromPage && fromPage === 'patientHistory' && (
                          <Row className="mt-2 mb-2">
                            <Col className="text-center">
                              {isLoading ? (
                                <LoadingButton btnFull="yes" />
                              ) : (
                                <Button
                                  variant="primary"
                                  size="sm"
                                  style={{ width: 'inherit' }}
                                  onClick={() => handleSubmit()}
                                >
                                  <b>Done</b>
                                </Button>
                              )}
                            </Col>
                          </Row>
                        )}
                      </Tab.Content>
                    </Tab.Container>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddPatientInfo;
